<!-- 这是一个海报绘制组件用来合成海报和分享二维码 -->
<template>
  <div v-loading="loading" class="posterDrawing">
    <canvas id="canvas"></canvas>
    <img v-if="show" id="posterImg" crossOrigin="Anonymous" :src="imgUrl" alt="">
    <div id="qrcode"></div>
    <img id="resultImg" :src="imgInfo" alt="">
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    ratio: { // 二维码和背景图片比例
      type: Number,
      default: 1
    },
    leftRatio: { // 左边距比例
      type: Number,
      default: 0.682
    },
    topRatio: { // 上边距比例
      type: Number,
      default: 0.8775
    }
  },
  data() {
    return {
      imgInfo: '', // 生成的图片信息
      time: 0,
      loading: false
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.loading = true
          this.$nextTick(async () => {
            let { ctx, canvas } = await this.drawImg()
            this.drawQrCode(ctx, canvas)
            this.loading = false
          })
        } else {
          this.loading = false
        }
      },
      immediate: true
    }
  },
  methods: {
    // 模拟长按调用APP下载弹框方法
    downImg() {
      let name = '我的专属海报.png'
      var link = document.createElement('a');
      link.href = this.imgInfo;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // base64转文件
    getFile(name) {
      let arr = this.imgInfo.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },
    // 绘制图片
    drawImg() {
      return new Promise((resolve) => {
        let canvas = document.getElementById("canvas");
        let img = document.getElementById('posterImg');
        img.onload = () => {
          let rect = img.getBoundingClientRect();
          let dpr = window.devicePixelRatio;
          canvas.width = rect.width * dpr;
          canvas.height = rect.height * dpr;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, rect.width * dpr, rect.height * dpr);
          ctx.beginPath();
          resolve({ ctx, canvas })
        }
      })
    },
    // 绘制二维码
    drawQrCode(ctx, canvas) {
      let qrCodeDom = document.getElementById('qrcode')
      qrCodeDom.innerHTML = ''
      let posterImgRect = document.getElementById('posterImg').getBoundingClientRect()
      let dpr = window.devicePixelRatio;
      let w = posterImgRect.width * this.ratio
      new QRCode(qrCodeDom, {
        width: w * dpr,
        height: w * dpr,
        text: this.url
      })
      let qrCodeCanvas = qrCodeDom.getElementsByTagName('canvas')[0]
      let qrCodeCtx = qrCodeCanvas.getContext('2d')
      let imgData = qrCodeCtx.getImageData(0, 0, qrCodeCanvas.width, qrCodeCanvas.height)
      let left = posterImgRect.width * dpr * this.leftRatio
      let top = posterImgRect.height * dpr * this.topRatio
      ctx.putImageData(imgData, left, top)
      ctx.beginPath();
      this.imgInfo = canvas.toDataURL('image/png');
    },
  }
}
</script>

<style lang="scss">
.posterDrawing {
  width: 100%;
  position: relative;

  #canvas {
    width: 100%;
    position: absolute;
    z-index: 1;
  }

  #qrcode {
    position: absolute;
    right: 0;
    top: 0;
    visibility: hidden;
    z-index: 3;
  }

  #posterImg {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 0;
    visibility: hidden;
  }

  #resultImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    height: auto;
  }
}
</style>